// extracted by mini-css-extract-plugin
export default {"container":"ForumsList_container__LoTPn"};